import { FunctionComponent, ReactNode } from 'react';

interface VehicleListFilterSectionProps {
  title?: string;
  wrapperClass?: string;
  children: ReactNode;
  titleSide?: ReactNode;
}

const VehicleListFilterSection: FunctionComponent<
  VehicleListFilterSectionProps
> = ({ children, wrapperClass, title, titleSide }) => {
  return (
    <section className={wrapperClass}>
      {title ? (
        <div className="mb-2 flex flex-wrap items-end gap-2">
          <div className="text-18px font-medium">{title}</div>
          {titleSide}
        </div>
      ) : null}
      <div>{children}</div>
    </section>
  );
};

export default VehicleListFilterSection;
